import styled from '@emotion/styled'

export const V2L2WorkItemDetailRoot = styled.div(({theme}) => ({
	border: `1px solid ${theme.colors.lines}`,
	borderRadius: theme.borderRadius,
	overflow: 'hidden',
	display: 'grid',
	gridTemplateRows: 'max-content 1fr max-content'
}))

export const V2L2WorkItemDetailTitle = styled.div<{ready: boolean}>(({theme, ready}) => ({
	fontSize: `${18/16}rem`,
	fontWeight: 600,
	color: ready ? 'inherit' : theme.colors.stopRed,
	height: '5rem',
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	gap: '0.5rem',
	paddingLeft: '1.5rem',
	paddingRight: '1.5rem',
}))

export const V2L2WorkItemDetailContent = styled.div(({theme}) => ({
	flexGrow: 1,
	overflowY: 'auto',
	backgroundColor: theme.colors.second,
	display: 'grid',
	gridTemplateColumns: '1fr 1fr 1fr',
	gridTemplateRows: 'max-content',
	rowGap: '1rem',
	columnGap: '3rem',
	alignContent: 'start',
	padding: '1.5rem',
	fontSize: '14px',
}))

export const V2L2WorkItemDetailActions = styled.div({
	display: 'flex',
	flexDirection: 'row',
	columnGap: '1rem',
	padding: '1.25rem 1.5rem',
	fontSize: '14px',
})
